import { CCCLinkList, LinkListItem } from "../components/link-list";
import { CategoryJsonPage } from "../core/interfaces/JsonPage";
import { PageDirection } from "../core/interfaces/Pagination";
import { VanillaDiscussionsPage } from "../core/interfaces/VanillaApi";
import { selectAnchor } from "../core/utilities";
import CategoryModel from "../models/CategoryModel";
import DiscussionModel from "../models/DiscussionModel";

// components
import "../components/link-list";

export interface scMapItem {
  forum: string;
  tag: string;
}
export default class ReportSharingCenterController {
  $anchorDiv: HTMLElement = null;
  $list: CCCLinkList = null;
  sharingCenterMap: Map<string, scMapItem> = new Map();
  pages: Map<number, VanillaDiscussionsPage> = new Map();
  limit = 30;
  currentPage = 0;
  requestedPage = -1;
  direction: PageDirection;
  mapItem: scMapItem;
  catJson: CategoryJsonPage = null;

  constructor() {
    this.sharingCenterMap.set("hcm-taleo-enterprise-report-sharing-center", {
      forum: "hcm-reporting-and-analytics-taleo-enterprise",
      tag: "Report Sharing Center",
    });
    this.sharingCenterMap.set("learn-report-sharing-center", {
      forum: "hcm-reporting-and-analytics-for-taleo-learn",
      tag: "Learn Report Sharing Center",
    });
  }

  init(categoryName: string, anchor: string, limit = 30): void {
    try {
      if (this.sharingCenterMap.has(categoryName)) {
        this.limit = limit;
        this._getAnchor(anchor);
        console.debug("Report Sharing Center - Anchor:", this.$anchorDiv);
        this.mapItem = this.sharingCenterMap.get(categoryName);
        this._addListHtml(this.mapItem);
      }
    } catch (err) {
      console.error(err);
    }
  }

  private _getAnchor(anchor: string): void {
    this.$anchorDiv = selectAnchor(anchor);
    if (this.$anchorDiv === null) {
      throw `Report Sharing Center - ${anchor} element not found in DOM`;
    }
  }

  private _addListHtml(item: scMapItem): void {
    this.$list = document.createElement("ccc-link-list") as CCCLinkList;
    this.$anchorDiv.append(this.$list);
    this.$list.addEventListener("ccc-link-list-pagination", () => {
      this._handlePagination();
    });

    this._loadLinks(item).then((items) => {
      this._parseLinks(items);
    });
  }

  private _parseLinks(links: Array<LinkListItem>): void {
    this.$list.setKeyState("emptyListMsg", "No discussions found");
    this.$list.setKeyState("links", links);
    this.$list.loading = false;
  }

  private _handlePagination(): void {
    this.$list.loading = true;
    this.$list.hidePagination();
    this.$list.setKeyState("emptyListMsg", "Loading discussions");
    this.$list.setKeyState("links", []);

    this.requestedPage =
      this.direction === PageDirection.next
        ? this.currentPage + 1
        : this.currentPage - 1;
    this._loadLinks(this.mapItem).then((items) => {
      this._parseLinks(items);
    });
  }

  private async _loadLinks(item: scMapItem): Promise<Array<LinkListItem>> {
    try {
      if (this.catJson === null) {
        this.catJson = await CategoryModel.loadCategoryJson(item.forum);
      }

      let page: VanillaDiscussionsPage = null;
      if (this.pages.has(this.requestedPage)) {
        page = this.pages.get(this.requestedPage);
      } else {
        page = await DiscussionModel.getVanillaDiscussionsPage(
          this.catJson.CategoryID,
          this.limit,
          [item.tag],
          false,
          null,
          this.requestedPage
        );
      }
      const data = DiscussionModel.pageData2LinkList(page.data, false);

      if (page.pagination.size > 0) {
        let pageNr = -1;
        if (page.pagination.has(PageDirection.next)) {
          // show next
          pageNr = Number(page.pagination.get(PageDirection.next).page) - 1;
          this.direction = PageDirection.next;
          this.$list.setKeyState("pagination", "Next");
        } else if (page.pagination.has(PageDirection.previous)) {
          // show previous
          pageNr = Number(page.pagination.get(PageDirection.previous).page) + 1;
          this.direction = PageDirection.previous;
          this.$list.setKeyState("pagination", "Previous");
        }
        this.pages.set(pageNr, page);
        this.currentPage = pageNr;
        this.$list.showPagination();
      }

      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  }
}
